
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freshers",
      function () {
        return require("private-next-pages/freshers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freshers"])
      });
    }
  